<top-menu [showPrint]="true" [showFilter]="true" [filtered]="!!actualFilterCount" (filter)="filter()"></top-menu>
<mobile-menu></mobile-menu>
<loader-pane-fragment [trace]="traceName"></loader-pane-fragment>
<calendar [filterPage]="filterPage" [isSingleEvent]="true"></calendar>